// import avatar from "../assets/team/avatar.png";
import simon from "../assets/team/simon.jpg";
import balu from "../assets/team/balu.jpg";
import hannah from "../assets/team/hannah.jpg";
import jeba from "../assets/team/jeba.png";
import rajesh from "../assets/team/rajesh.png";
import thomas from "../assets/team/thomas.jpeg";
import devakumar from "../assets/team/devakumar.jpg";
import arun from "../assets/team/arun.jpg";
import amit from "../assets/team/amit.jpg";
import neenu from "../assets/team/neenu.jpg";
import manu from "../assets/team/manu.jpg";
import arvind from "../assets/team/arvind.jpg";
import justin from "../assets/team/justin.jpg";
import joy from "../assets/team/joy.jpg";
// import sathya from "../assets/team/sathya.jpg";
import sathya2 from "../assets/team/sathya2.jpeg";
import ari from "../assets/team/ari.jpg";
import geetha from "../assets/team/geetha.jpg";
import abhijit from "../assets/team/abhijit.jpg";
import anitha from "../assets/team/anitha.jpg";
import aparna from "../assets/team/aparna.jpeg";
import rajiv from "../assets/team/rajiv.jpg";
import finle from "../assets/team/finle.jpg";
import Joel from "../assets/team/Joel.jpg";
import timothy from "../assets/team/timothy.JPG";
import anjana from "../assets/team/anjana.jpeg";
import praveen from "../assets/team/praveen.jpg";
import hassan from "../assets/team/hassan.jpeg";
// import avatar2 from "../assets/team/qirail_logo.png";
import axa from "../assets/team/Axa.jpeg";
import benny from "../assets/team/benny.jpeg";
import gly from "../assets/team/gly.jpeg";
import jino from "../assets/team/jino.jpeg";
import sho from "../assets/team/shobana.jpeg";
import kuttysha from "../assets/team/kuttysha.jpeg";
import sasha from "../assets/team/sasha.jpeg";


export const mainTeam = {
    title: "Lead Team",
    members: [{
            name: "Dr Simon Pavamani",
            designation: "Lab Head",
            department: "Radiation Oncology",
            image: simon,
            about: "Professor",
            email: "simon@cmcvellore.ac.in",
            linkedin: "https://www.linkedin.com/in/simon-pavamani-467b9869/"
        },
        {
            name: "Dr Balu Krishna Sasidharan",
            designation: "Clinical Lead in Radiomics and AI",
            department: "Radiation Oncology",
            image: balu,
            about: "Professor",
            email: "balunair@cmcvellore.ac.in",
            linkedin: "https://www.linkedin.com/in/balukrishna-s/"
        },
        {
            name: "Dr Hannah Mary Thomas T",
            designation: "Research Team Lead",
            department: "Biomedical Informatics Unit (BMIU)",
            image: hannah,
            about: "Imaging Scientist",
            email: "hannah.thomas@cmcvellore.ac.in",
            linkedin: "https://www.linkedin.com/in/hannah-mary-thomas-t-838a0113/"
        },
        {
            name: "Dr Devakumar D",
            designation: "Computational Analysis Lead",
            department: "Nuclear Medicine",
            image: devakumar,
            about: "Professor",
            email: "devakumar@cmcvellore.ac.in",
            linkedin: "https://www.linkedin.com/in/devakumar-devadhas-459b3019/?originalSubdomain=in"
        },
        {
            name: "Dr Benny Kuchipudi",
            designation: "",
            department: "Radiation Oncology",
            image: benny,
            about: "Assistant Professor",
            email: "rajendra.bennyk@cmcvellore.ac.in",
            linkedin: "https://www.linkedin.com/in/benny-kuchipudi-18404aba/"
        },
        {
            name: "Dr Jino Victor Wilson",
            designation: "",
            department: "Radiation Oncology",
            image: jino,
            about: "Assistant Professor",
            email: "jino.victor@cmcvellore.ac.in",
            linkedin: ""
        },
        {
            name: "Sathya A",
            designation: "Research Associate",
            department: "Radiation Oncology | BMIU",
            image: sathya2,
            about: "Biomedical Engineer",
            email: "sathya.a2018@vitalum.ac.in",
            linkedin: "https://www.linkedin.com/in/sathya-a-christopher/"
        },
        {
            name: "Anjana Chandran",
            designation: "Consultant Nutritionist",
            department: "Radiation Oncology",
            image: anjana,
            about: "Research Coordinator",
            linkedin: "https://www.linkedin.com/in/anjana-chandran-989414236/"
        },
        {
            name: "Praveenraj C",
            designation: "Research Associate",
            department: "Biomedical Informatics Unit (BMIU)",
            image: praveen,
            about: "Statistician",
            email: "",
            linkedin: "https://www.linkedin.com/in/praveenraj-c-748715129/"
        },
        {
            name: "Hasan Shaikh",
            designation: "Clinical Data Manager",
            department: "Radiation Oncology",
            image: hassan,
            about: "Software Engineer",
            email: "",
            linkedin: "https://www.linkedin.com/in/hasann-shaikh/"
        },
        {
            name: "Achsah Christine Godfred",
            designation: "Clinical Psychologist",
            department: "Radiation Oncology",
            // about: ""
            image: axa,
            email: "",
            linkedin: "https://www.linkedin.com/in/achsah-christine/",
        },
        {
            name: "Dr Glynis Florence Francis",
            designation: "Surgical Resident",
            department: "Head & Neck Surgery",
            image: gly,
            // about: "",
            email: "",
            linkedin: ""
        },
        {
            name: "Dr Shobana",
            designation: "Consultant Nutritionist",
            department: "Radiation Oncology",
            image: sho,
            // about: "",
            email: "manjusha.mammen.inst@cmcvellore.ac.in",
            linkedin: ""
        },
        {
            name: "Shamol Benny",
            designation: "Consultant Nutritionist",
            department: "Radiation Oncology",
            image: sasha,
            // about: "",
            email: "shamol.benny.inst@cmcvellore.ac.in",
            linkedin: "https://www.linkedin.com/in/shamol-benny-94a6a1344/"
        },
        {
            name: "Manjusha Sharon",
            designation: "Clinical Sociologist",
            department: "Radiation Oncology",
            image: kuttysha,
            // about: "",
            email: "manjusha.mammen.inst@cmcvellore.ac.in",
            linkedin: ""
        },
    ],
};

export const clinicalTeam = {
    group: "Clinical Team",
    subTeam: [{
            title: "Head, Neck & Thoracic Cancer Studies",
            members: [{
                    name: "Dr Rajesh I",
                    about: "",
                    department: "Radiation Oncology",
                    image: rajesh,
                    designation: 'Professor',
                },
                {
                    name: "Dr Manu Mathew",
                    about: "",
                    department: "Radiation Oncology",
                    image: manu,
                    designation: 'Associate Professor',
                },
                {
                    name: "Dr Aparna Irodi",
                    about: "",
                    department: "Radiodiagnosis",
                    image: aparna,
                    designation: 'Professor',
                },
                {
                    name: "Dr Rajiv Michael",
                    about: "",
                    department: "Head & Neck Surgery",
                    image: rajiv,
                    designation: 'Professor',
                },
                {
                    name: "Dr Amit Tirkey",
                    about: "",
                    department: "Head & Neck Surgery",
                    image: amit,
                    designation: 'Professor',
                },
                {
                    name: "Dr Justin Benjamin",
                    about: "",
                    department: "Nuclear Medicine",
                    image: justin,
                    designation: 'Assistant Professor',
                },
                {
                    name: "Dr Timothy Peace Balasingh",
                    // about: "Associate professor in Radiation physics",
                    department: "Radiation Oncology",
                    image: timothy,
                    designation: 'Chief Medical Physicist',
                },
                {
                    name: "Dr Henry Finlay Godson",
                    // about: "Associate professor in Radiation physics",
                    department: "Radiation Oncology",
                    image: finle,
                    designation: 'Radiation Safety Officer',
                },
                {
                    name: "Joel T",
                    about: "",
                    department: "Radiation Oncology",
                    image: Joel,
                    designation: 'Therapeutic Radiographer',
                },

            ]
        },
        {
            title: "Rectal Cancer Studies",
            members: [{
                    name: "Dr Thomas Samuel",
                    about: "",
                    department: "Radiation Oncology",
                    image: thomas,
                    designation: 'Professor & HOD',
                },
                {
                    name: "Dr Jeba Karunya",
                    about: "",
                    department: "Radiation Oncology",
                    image: jeba,
                    designation: 'Associate Professor',
                },
                {
                    name: "Dr Arvind S",
                    about: "",
                    department: "Radiation Oncology",
                    image: arvind,
                    designation: 'Assistant Professor',
                },
                {
                    name: "Dr Neenu Oliver John",
                    about: "",
                    department: "Radiation Oncology",
                    image: neenu,
                    designation: 'Assistant Professor',
                },
            ]
        },
        {
            title: "Pituitary Adenomas Studies",
            members: [{
                    name: "Dr Ari Chacko",
                    about: "",
                    department: "Neurosurgery",
                    image: ari,
                    designation: 'Professor',
                },
                {
                    name: "Dr Abhijit Honavar",
                    about: "",
                    department: "Neurosurgery",
                    image: abhijit,
                    designation: 'Resident',
                },
                {
                    name: "Dr Geetha Chacko",
                    about: "",
                    department: "Pathology",
                    image: geetha,
                    designation: 'Professor and Head',
                },
                {
                    name: "Dr Anitha Jasper",
                    about: "",
                    department: "Radiology",
                    image: anitha,
                    designation: 'Professor',
                },
            ]
        },
        {
            title: "e-PROMS",
            members: [
                {
                    name: "Dr Joy John Mammen",
                    about: "",
                    department: "Immunohematology & Transfusion Medicine",
                    image: joy,
                    designation: 'Professor',
                },
                {
                    name: "Arun Zechariah",
                    about: "",
                    department: "Education Technology Unit",
                    image: arun,
                    designation: "Systems Manager",
                },
            ]
        },
    ]
}
